<template>
  <div class="role-user-manage2">
    <base-table
      ref="table"
      url="/user/findByRole"
      :toolbar="toolbar"
      :columns="columns"
      :init-search="false"
    ></base-table>
    <base-dialog
      title="新增用户"
      v-model="showDialog"
      @opened="refreshUserView"
      @close="addUserClose"
      :show-ok="false"
      :show-cancel="false"
    >
      <base-table
        style="height: 400px"
        ref="tableAddUser"
        url="/user/findByRoleView"
        :toolbar="toolbarAddUser"
        :columns="columnsAddUser"
        :init-search="false"
      ></base-table>
    </base-dialog>
    <form v-show="false" ref="importForm">
      <input
        type="file"
        ref="importFile"
        accept=".xlsx"
        @change="onImportUserFileChange"
      />
    </form>
  </div>
</template>
<script>
import { exportXlsxFile, readXlsxFileToJson } from '../plugins/exceljs'
export default {
  name: 'role-user-manage2',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    active: Boolean, //组件是否激活
    roleid: String,
    roleName: String,
    project: Object,
    domain: String,
    gid: String
  },
  data() {
    return {
      showDialog: false,
      shouldRefreshUser: false,
      exportUserLoading: false,
      importUserLoading: false,
      toolbar: {
        formItems: [
          {
            label: '账号',
            prop: 'id',
            cp: this.$ComparePatterns.Matchs,
            bind: { style: 'width: 120px' }
          },
          {
            label: '姓名',
            prop: 'nick_name',
            cp: this.$ComparePatterns.Matchs,
            bind: { style: 'width: 120px' }
          }
        ],
        query: {
          project: this.project.id,
          role: this.roleid,
          SortFields: JSON.stringify([{ Field: 'id', Order: 1 }])
        }
      },
      columns: [
        { bind: { label: '账号', prop: 'id' } },
        { bind: { label: '姓名', prop: 'nick_name' } },
        {
          bind: { label: '状态', prop: 'disabled' },
          default: {
            component: 'user-state'
          }
        },
        {
          bind: { label: '操作', prop: 'Name', width: 230 },
          header: {
            component: 'cell-render-vnode',
            bind: {
              vnode: (scope) => {
                return (
                  <div>
                    <el-button
                      type='primary'
                      size='mini'
                      onClick={() => {
                        this.showDialog = true
                      }}
                    >
                      新增
                    </el-button>
                    <el-button
                      size='mini'
                      loading={this.exportUserLoading}
                      onClick={() => {
                        this.beginExportUser()
                      }}
                    >
                      导出
                    </el-button>
                    <el-button
                      size='mini'
                      loading={this.importUserLoading}
                      onClick={() => {
                        this.beginImportUser()
                      }}
                    >
                      导入
                    </el-button>
                  </div>
                )
              }
            }
          },
          default: {
            component: 'cell-button',
            bind: { label: '删除', type: 'text', icon: 'el-icon-delete' },
            on: {
              click: (scope) => {
                if (confirm('确定删除?')) {
                  this.doDelRoleUser(scope.row).then((result) => {
                    if (result) {
                      this.$message({
                        type: 'success',
                        message: '删除角色下属用户成功'
                      })
                      this.refreshUser()
                    }
                  })
                }
              }
            }
          }
        }
      ],
      toolbarAddUser: {
        formItems: [
          {
            label: '账号',
            prop: 'id',
            cp: this.$ComparePatterns.Matchs,
            bind: { style: 'width: 120px' }
          },
          {
            label: '姓名',
            prop: 'nick_name',
            cp: this.$ComparePatterns.Matchs,
            bind: { style: 'width: 120px' }
          }
        ],
        query: {
          project: this.project.id,
          role: this.roleid,
          SortFields: JSON.stringify([{ Field: 'id', Order: 1 }])
        }
      },
      columnsAddUser: [
        { bind: { label: '账号', prop: 'id' } },
        { bind: { label: '姓名', prop: 'nick_name' } },
        {
          bind: { label: '状态', prop: 'disabled' },
          default: {
            component: 'user-state'
          }
        },
        {
          bind: { label: '操作', prop: 'added', width: 100 },
          default: {
            component: 'role-add-user',
            bind: {
              add: (row) => {
                return this.doAddRoleUser(row)
              },
              del: (row) => {
                return this.doDelRoleUser(row)
              }
            }
          }
        }
      ]
    }
  },
  computed: {
    table() {
      return this.$refs.table
    },
    tableAddUser() {
      return this.$refs.tableAddUser
    },
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('change', newVal)
      }
    }
  },
  methods: {
    refreshUser() {
      clearTimeout(window.refreshUserTimeout)
      window.refreshUserTimeout = setTimeout(() => {
        this.$refs.table.refreshData()
      }, 100)
    },
    refreshUserView() {
      this.toolbarAddUser.query.role = this.roleid
      this.tableAddUser.refreshData()
    },
    addUserClose() {
      if (this.shouldRefreshUser) {
        this.refreshUser()
      }
      this.shouldRefreshUser = false
    },
    doAddRoleUser(row) {
      return this.$post('/ugroup/add', {
        parameters: JSON.stringify({
          uid: row.id,
          domain: this.domain,
          gid: this.gid
        })
      })
        .then((resp) => {
          if (resp.data.code == 0) {
            row.added = true
            this.shouldRefreshUser = true
            return true
          } else {
            this.$message(`添加角色下属用户失败: ${resp.data.msg}`)
          }
        })
        .catch((error) => {
          console.error('添加角色下属用户发生异常:', error)
          this.$message(`添加角色下属用户发生异常: ${error.message}`)
        })
    },
    doDelRoleUser(row) {
      return this.$post('/ugroup/remove', {
        parameters: JSON.stringify({
          uid: row.id,
          domain: this.domain,
          gid: this.gid
        })
      })
        .then((resp) => {
          if (resp.data.code == 0) {
            row.added = false
            this.shouldRefreshUser = true
            return true
          } else {
            this.$message(`删除角色下属用户失败: ${resp.data.msg}`)
          }
        })
        .catch((error) => {
          console.error('删除角色下属用户发生异常:', error)
          this.$message(`删除角色下属用户发生异常: ${error.message}`)
        })
    },
    beginExportUser() {
      this.exportUserLoading = true
      this.$post('/user/findByRole', {
        project: this.project.id,
        role: this.roleid,
        PageIndex: 1,
        PageSize: 10000,
        SortFields: JSON.stringify([{ Field: 'id', Order: 1 }])
      })
        .then((resp) => {
          this.exportUserLoading = false
          if (resp.data.code == 0) {
            this.endExportUser(resp.data.data.Data || [])
          } else {
            this.$message(`导出失败:${resp.data.msg}`)
          }
        })
        .catch((err) => {
          this.exportUserLoading = false
          console.error('导出发生异常=>', err)
          this.$message(`导出发生异常:${err}`)
        })
    },
    endExportUser(exportData) {
      console.log('exportData', exportData)
      if (exportData.length == 0) {
        this.$message('没有数据可导出')
        return
      }
      exportXlsxFile(
        `${this.project.name || ''}${this.project.name ? '_' : ''}${
          this.roleName || ''
        }${this.roleName ? '_' : ''}下属账号_${new Date().getTime()}.xlsx`,
        [
          { header: '账号', key: 'id', width: 15 },
          { header: '姓名', key: 'nick_name', width: 15 }
        ],
        {},
        exportData
      )
    },
    beginImportUser() {
      this.$refs.importFile.click()
    },
    async onImportUserFileChange(event) {
      var file = event.target.files[0]
      if (file) {
        console.log('file', file)
        var ext = file.name.split('.').pop()
        if (ext != 'xlsx') {
          this.$message('请上传xlsx文件')
          return
        }
        try {
          var data = await readXlsxFileToJson(file, {
            keyMap: {
              账号: 'uid',
              姓名: 'nick_name'
            }
          })
          console.log('readXlsxFileToJson=>data', data)
          if (data.length == 0) {
            this.$message('没有数据可导入')
            return
          }
          if (data.some((item) => !item.uid && !item.nick_name)) {
            this.$message('账号/姓名不能同时为空，请检查文件内容')
            return
          }
          this.endImportUser(data)
        } catch (error) {
          console.error('读取xlsx文件发生异常=>', error)
          this.$message(`读取${file.name}文件失败，请检查文件内容`)
        } finally {
          this.$refs.importForm.reset()
        }
      }
    },
    endImportUser(data) {
      this.importUserLoading = true
      this.$postObj('/ugroup/importUsers', {
        domain: this.project.domain,
        project: this.project.id,
        roleName: this.roleName,
        users: data.map((item) => {
          return {
            id: item.uid,
            nick_name: item.nick_name
          }
        })
      })
        .then((resp) => {
          this.importUserLoading = false
          if (resp.data.code == 0) {
            this.$message({
              message: '导入成功',
              type: 'success'
            })
            this.refreshUser()
          } else {
            this.$message(`导入失败:${resp.data.msg}`)
          }
        })
        .catch((err) => {
          this.importUserLoading = false
          console.error('导入发生异常=>', err)
          this.$message(`导入发生异常:${err}`)
        })
    }
  },
  watch: {
    active: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refreshUser()
        }
      }
    },
    'project.id': {
      immediate: true,
      handler(newVal) {
        this.toolbar.query.project = newVal
        this.toolbarAddUser.query.project = newVal
        this.columnsAddUser[3].default.bind.project = newVal
        if (this.active) {
          this.refreshUser()
        }
      }
    },
    roleid: {
      immediate: true,
      handler(newVal) {
        this.toolbar.query.role = newVal
        this.toolbarAddUser.query.role = newVal
        this.columnsAddUser[3].default.bind.role = newVal
        if (this.active) {
          this.refreshUser()
        }
      }
    },
    domain: {
      immediate: true,
      handler(newVal) {
        this.columnsAddUser[3].default.bind.domain = newVal
      }
    },
    gid: {
      immediate: true,
      handler(newVal) {
        this.columnsAddUser[3].default.bind.gid = newVal
      }
    }
  }
}
</script>
<style lang="less">
.role-user-manage2 {
  height: 100%;
}
</style>
